export const FETCH_JOBS = "fetch_jobs";
export const SET_SEARCH_TERMS = "set_search_terms";
export const SET_CURRENT_JOB_KEYS = "set_current_job_keys";
export const SET_CURRENT_POPUP = "set_current_popup";
export const SET_PROGRESS = "set_progress";
export const SET_CURRENT_MODAL = "set_current_modal";
export const ADD_JOB_DESCRIPTION = "add_job_description";